<template>
  <div class="vr-link-btn" :class="{'is-suite': isSuite}">
    <div class="vr-link-btn__inner" v-if="vrUrl" @click="goToVr(vrUrl)">
      <img class="icon" :src="`${imgUrl}/vrImg/vrBtnIconBluePc.png`" alt="" />
      <div class="title">全景看舱房</div>
      <img class="arrow" :src="`${imgUrl}/vrImg/iconArrowBluePc.png`" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    vrUrl: {
      type: String,
      default() {
        return "";
      }
    },
    isSuite: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram'
    }
  },
  methods: {
    goToVr(str){
      window.open(`https://www.rcclchina.com.cn/${str}`,'_blank')
    }
  }
}
</script>
<style scoped lang="less">
.vr-link-btn {
  display: flex;
  align-items: center;
  height: 15px;
  cursor: pointer;
  box-sizing: content-box;
  padding-top: 14px;
  padding-bottom: 16px;
  &.is-suite {
    padding-top: 14px;
    padding-bottom: 0;
  }
  & .vr-link-btn__inner {
    display: flex;
    align-items: center;
    & .icon {
      width: 26px;
      height: 15px;
    }
    & .title {
      padding: 0 5px 0 7px;
      font-weight: normal;
      font-size: 16px;
      line-height: 15px;
      color: #057EC7;
    }
    & .arrow {
      width: 9px;
      height: 15px;
    }
  }
}
</style>